<template>
  <div>
    <container-red-x class="bg-primary container mt-lg-3 mt-0 mb-lg-5 mb-0 pb-4 md-elevation-6">
      <div class="container pt-4 pb-4">
        <div class="row text-white">
          <div class="col-sm-12">
            <h2 class="md-headline font-weight-bolder">Serviços</h2>
          </div>
          <div class="col-md-12">
            <widget-servico link="planos"
                            titulo="Planos"
                            :img-bg="require('../assets/background/bg_planet_fiber.png')"
                            class="mt-2">
            </widget-servico>
          </div>
        </div>
        <div class="row text-white mt-3">
          <div class="col-sm-12">
            <h2 class="md-headline font-weight-bolder">Auto Atendimento</h2>
          </div>
          <div class="col-sm-12 col-md-4 mt-md-0 mt-4">
            <widget-atendimento link="calculadora_plano"
                                :titulo="widgetAtendimento[0].titulo"
                                :img="widgetAtendimento[0].img">
            </widget-atendimento>
          </div>
          <div @click="toCentral" class="col-sm-12 col-md-4 text-decoration-none md-with-hover mt-md-0 mt-4">
            <widget-atendimento link=""
                                :titulo="widgetAtendimento[1].titulo"
                                :img="widgetAtendimento[1].img">
            </widget-atendimento>

          </div>
          <div class="col-sm-12 col-md-4 mt-md-0 mt-4">
            <widget-atendimento link="faq"
                                :titulo="widgetAtendimento[2].titulo"
                                :img="widgetAtendimento[2].img">
            </widget-atendimento>
          </div>
          <div @click="showModalCall = true" class="col-sm-12 col-md-6 mt-md-4 mt-4">
            <widget-atendimento link=""
                                :titulo="widgetAtendimento[4].titulo"
                                :img="widgetAtendimento[4].img">
            </widget-atendimento>
          </div>
          <div class="col-sm-12 col-md-6 mt-md-4 mt-4">
            <widget-atendimento link="noticias"
                                :titulo="widgetAtendimento[3].titulo"
                                :img="widgetAtendimento[3].img">
            </widget-atendimento>
          </div>
        </div>
      </div>
    </container-red-x>
    <md-dialog :md-active.sync="showModalCall">
      <md-dialog-title>Ligamos para Você</md-dialog-title>

      <md-dialog-content>
        <FormCallToYou />
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showModalCall = false">Fechar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
  import ContainerRedX from './ContainerRedX';
  import WidgetServico from './WidgetServico';
  import WidgetAtendimento from './WidgetAtendimento';

  import CalcImg from '../assets/icon/calc_512_red.png'
  import PeopleInfo from '../assets/icon/people_info_512_red.png'
  import XatImg from '../assets/icon/xat_512_red.png'
  import NewsImg from '../assets/icon/newspaper_512_red.png'
  import CallMeImg from '../assets/icon/call_me_512_red.png'
  import FormCallToYou from "./FormCallToYou";

  export default {
    name: 'ServicoBox',
    data() {
      return {
        showModalCall: false,
        widgetAtendimento: [
          { titulo: "Calculadora de Plano", img: CalcImg },
          { titulo: "Central do Assinante", img: PeopleInfo},
          { titulo: "Perguntas Frequêntes", img: XatImg },
          { titulo: "Notícias", img: NewsImg },
          { titulo: "Ligamos para Você", img: CallMeImg },
        ]
      }
    },
    methods: {
      toCentral() {
        window.open(this.$store.state.cityInfo.centralAssinanteUrl, '_blank')
      }
    },
    components: {FormCallToYou, WidgetAtendimento, WidgetServico, ContainerRedX }
  }
</script>
